import styled from "styled-components";

// Container for the entire shimmer
export const ShimmerContainer = styled.div(({ theme }) => ({
    width: "100%",
    minHeight: "100vh",
    backgroundColor: theme.colors[theme.colorMode].canvas_Primary,
    color: theme.colors[theme.colorMode].text_inverse_Highest_Emphasis,
    display: "flex",
    flexDirection: "column",
}));

// Content area
export const ShimmerContent = styled.div(({ theme }) => ({
    width: "100%",
    flex: 1,
    padding: "24px 20px",
    background: `linear-gradient(to bottom, ${theme.colors[theme.colorMode].canvas_Primary} 0%, ${
        theme.colors[theme.colorMode].background_Secondary
    } 100%)`,
}));

// Content blocks with rounded corners
export const ShimmerBlock = styled.div<{ height: number; marginBottom: number }>(({ theme, height, marginBottom }) => ({
    height: `${height}px`,
    marginBottom: `${marginBottom}px`,
    backgroundColor: theme.colors[theme.colorMode].background_Secondary_Alpha,
    borderRadius: 12,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
}));
